import type { LocationSchema, TeamSchema } from '@libs/data-access/entities'
import { Select } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import React from 'react'
import type { FC } from 'react'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'

type Props = {
  control: Control
  errors: FieldErrors
  disabled: boolean
  locations: LocationSchema[]
  selectedLocationId?: number
  teams: TeamSchema[]
  setValue: Function
}
export const LocationAndTeamFields: FC<Props> = ({
  control,
  errors,
  disabled,
  locations,
  selectedLocationId,
  teams,
  setValue
}) => {
  const { t } = usePlanningFormTranslation()
  const locationOptions = locations.map(location => ({
    value: location.id.toString(),
    label: location.name
  }))

  const filteredTeams = teams.filter(
    ({ location_id: teamLocationId }) => teamLocationId === selectedLocationId
  )

  const filteredTeamsOptions = filteredTeams.map(team => ({
    value: team.id.toString(),
    label: team.name
  }))

  const handleChangeLocation = (value: string) => {
    setValue(
      'location',
      locationOptions.find(x => x.value === value)
    )
  }
  const handleChangeTeam = (value: string) => {
    setValue(
      'team',
      filteredTeamsOptions.find(x => x.value === value)
    )
  }

  return (
    <div>
      {locations.length > 1 && (
        <Controller
          name='location'
          control={control}
          render={({ field: { value } }) => (
            <Select
              clearable
              fillWidth
              className='mb-2'
              dropdownHeight='m'
              dropdownWidth='target'
              onChange={handleChangeLocation}
              options={locationOptions}
              value={value.value}
              disabled={disabled}
              errorMessage={formatErrors({
                inputName: 'location',
                errors
              })}
              label={t('component.fieldLocationAndTeam.location')}
            />
          )}
        />
      )}

      {filteredTeams.length > 1 && (
        <Controller
          name='team'
          control={control}
          render={({ field: { value } }) => (
            <Select
              clearable
              fillWidth
              className='mb-2'
              dropdownHeight='m'
              dropdownWidth='target'
              onChange={handleChangeTeam}
              options={filteredTeamsOptions}
              value={value.value}
              disabled={disabled}
              errorMessage={formatErrors({
                inputName: 'team',
                errors
              })}
              label={t('component.fieldLocationAndTeam.team')}
            />
          )}
        />
      )}
    </div>
  )
}
